<template>
    <div class="row" id="reports">
      <div class="col-12">
        <v-col
          v-if="downloading"
          class="subtitle-1 text-center"
          cols="12"
        > Cargando por favor espere...
        </v-col>
        <v-progress-linear
          indeterminate
          :background-color="backgroundLoadingColor"
          :color="loadingColor"
          height="10"
          v-if="downloading"
        ></v-progress-linear>
        <v-form @submit.prevent="reset" @keydown="form.onKeydown($event)" ref="form" lazy-validation>
          <v-container grid-list-xl>
            <toolbar
              :title="title"
              :loading="form.busy"
              :buttons="buttons"
              @getBook="getBook"
              @getList="getList"
            />
            <v-layout :id="ref" class="wrap justify-space-around form-body">
              <v-col lg="10" md="10" sm="10" cols="12">
                <vuetify-select :states="cat_province_id" />
              </v-col>
              <v-col lg="2" md="2" sm="2" cols="12">
                <v-switch
                  v-model="form.igtf"
                  label="Extendido"
                  :color="themeColor"
                  :input-value="form.igtf === 1"
                />
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <v-select
                    :items="tiposLV"
                    :menu-props="{ top: false, offsetY: true }"
                    label="Tipo"
                    v-model="form.tipo"
                    @change="changeTipo"
                />
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <v-menu
                    v-model="form.dateMenu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedStart"
                        label="Fecha de Emisión Inicio"
                        :rules="[rules.required]"
                        required
                        readonly
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-date-picker
                        :color="themeColor"
                        :max="form.dateMax"
                        v-model="form.dateStart"
                        @input="form.dateMenu1 = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="12" style="padding: 0 !important;">
                      <v-btn
                        block
                        :color="themeColor"
                        dark
                        @click="today('one')"
                      >
                        HOY
                      </v-btn>
                    </v-col>
                  </v-menu>
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <v-menu
                    v-model="form.dateMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedEnd"
                        label="Fecha de Emisión Fin"
                        :rules="[rules.required]"
                        required
                        readonly
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-date-picker
                        :color="themeColor"
                        v-model="form.dateEnd"
                        :max="form.dateMax"
                        @input="form.dateMenu2 = false"
                      />
                    </v-col>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-btn
                        block
                        :color="themeColor"
                        dark
                        @click="today('two')"
                      >
                        HOY
                      </v-btn>
                    </v-col>
                  </v-menu>
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <vuetify-select-api-code
                  ref="refSucursales"
                  :api="sucursales.apiSucursales"
                  :multiple="sucursales.multiple"
                  :placeholder="sucursales.placeholder"
                  @eventupdate="updateSucursales"
                  :selected="sucursales.selectedSucursales"
                  :enterprise_id="form.enterprise_id"
                  :showCode="true"
                />
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12" v-show="showFilters">
                <vuetify-select-api-code
                  ref="refExternos"
                  :api="externo.apiExternos"
                  :multiple="externo.multiple"
                  :placeholder="externo.placeholder"
                  @eventupdate="updateExternos"
                  :selected="externo.selectedExternos"
                  :enterprise_id="form.enterprise_id"
                  :showCode="true"
                />
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <vuetify-select-api-code
                  ref="refSeries"
                  :api="serie.apiSeries"
                  :multiple="serie.multiple"
                  :placeholder="serie.placeholder"
                  @eventupdate="updateSeries"
                  :selected="serie.selectedSeries"
                  :enterprise_id="form.enterprise_id"
                  :showCode="false"
                />
              </v-col>
              <v-col lg="4" md="4" sm="4" cols="12">
                <vuetify-select-collection
                  ref="refTiposDocumento"
                  :collection="tiposDocumento.collection"
                  :multiple="tiposDocumento.multiple"
                  :placeholder="tiposDocumento.placeholder"
                  @eventupdate="updateTiposDocumento"
                  :selected="tiposDocumento.selectedTiposDocumento"
                  :showCode="false"
                />
              </v-col>
              <v-col lg="2" md="2" sm="2" cols="12">
                <v-switch
                  v-model="form.municipio"
                  label="Por Municipios"
                  :color="themeColor"
                  :input-value="form.municipio === 1"
                  @change="clearMunicipio()"
                />
              </v-col>
              <v-col lg="6" md="6" sm="6" cols="12">
                <vuetify-select-api-code
                  v-show="form.municipio"
                  ref="refMunicipios"
                  :api="municipio.apiMunicipios"
                  :multiple="municipio.multiple"
                  :placeholder="municipio.placeholder"
                  @eventupdate="updateMunicipios"
                  :selected="municipio.selectedMunicipios"
                  :enterprise_id="form.enterprise_id"
                  :showCode="false"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </div>
      <v-row>
        <v-col class="col-12">
          <div v-if="dateCurrent">
            <p style="font-size: 1.5rem; text-align: center">Quedan</p>
            <flip-countdown :deadline="deadline" :labels="labels"></flip-countdown>
            <p style="font-size: 1.5rem; text-align: center">
              Para generar un nuevo Libro de Ventas
            </p>
          </div>
        </v-col>
        <v-col class="col-12">
          <strong>Total de Registros Encontrados: {{ this.totalDocument }}</strong>
          <br/><br/>
          <strong>Total de Archivos a Descargar: {{ this.laps }}</strong>
          <br/><br/>
          <v-progress-linear
            v-model="progress"
            height="25"
            :background-color="backgroundLoadingColor"
            :color="loadingColor"
            dark
            v-if="downloading"
          >
            <strong>{{ Math.ceil(progress) }}%</strong>
          </v-progress-linear>
        </v-col>
      </v-row>
    </div>
  </template>

  <script>
  import Form from 'vform';
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { format, parseISO } from 'date-fns';
  import FlipCountdown from 'vue2-flip-countdown';
  import Toolbar from '~/components/Toolbar';
  import 'vuetify/src/styles/main.sass';
  import VuetifySelect from '~/components/VuetifySelect';
  import VuetifySelectApiCode from '~/components/VuetifySelectApiCode';
  import VuetifySelectCollection from '~/components/VuetifySelectCollection';

  Form.axios = window.axios;
  export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('generateBook') };
    },
    components: {
      Toolbar,
      VuetifySelect,
      FlipCountdown,
      VuetifySelectApiCode,
      VuetifySelectCollection,
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        themeColor: 'theme/themeColor',
      }),
      ref() {
        return this.form.id;
      },
      deadline() {
        return moment(this.dateCurrent).add(this.daysLimit, 'hours').format('YYYY-MM-DD');
      },
      computedDateFormattedStart() {
          return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
      },
      computedDateFormattedEnd() {
          return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
      },
    },
    data: () => ({
      title: 'Generar Libro de Ventas',
      form: new Form({
        busy: false,
        dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        dateMax: format(parseISO(new Date(new Date().setDate(new Date().getDate() + 3)).toISOString()), 'yyyy-MM-dd'),
        dateMenu1: false,
        dateMenu2: false,
        enterprise_id: null,
        rif: null,
        offset: 0,
        limit: 200000,
        decimalPoint: null,
        end: false,
        tipo: 0,
        series: [],
        externos: [],
        sucursales: [],
        igtf: 0,
        tiposDocumento: [],
        municipio: 0,
        municipios: [],
      }),
      progress: 0,
      totalDocument: 0,
      laps: 0,
      buttons: [
        {
          id: 'generate',
          icon: 'mdi-download',
          name: 'Generar Libro de Ventas',
          event: 'getBook',
          color: 'success',
        },
        {
          id: 'list',
          icon: 'mdi-code-json',
          name: 'Generar Listado',
          event: 'getList',
          color: 'blue darken-1',
        },
      ],
      cat_province_id: '',
      labels: {
        days: 'Días',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos',
      },
      dateCurrent: '',
      daysLimit: 1,
      disabled: true,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      downloading: false,
      tiposLV: [
          { text: 'Todos', value: 0 },
          { text: 'Solo Propios', value: 1 },
          { text: 'Solo terceros', value: 2 },
      ],
      showFilters: false,
      serie: {
        selectedSeries: null,
        apiSeries: '/api/enterprises/getseries',
        multiple: true,
        placeholder: 'Series',
      },
      externo: {
        selectedExternos: null,
        apiExternos: '/api/catalogs/other_customers/getexternals',
        multiple: true,
        placeholder: 'Externo',
      },
      sucursales: {
        selectedSucursales: null,
        apiSucursales: '/api/enterprises/getsucursales',
        multiple: true,
        placeholder: 'Sucursales',
      },
      tiposDocumento: {
        selectedTiposDocumento: null,
        collection: [
          { code: 'V', name: 'VENEZOLANO' },
          { code: 'E', name: 'EXTRANJERO' },
          { code: 'J', name: 'JURÍDICO' },
          { code: 'P', name: 'PASAPORTE' },
          { code: 'G', name: 'GUBERNAMENTAL' },
          { code: 'C', name: 'COMUNAL' },
        ],
        multiple: true,
        placeholder: 'Tipos de Documento',
      },
      municipio: {
        selectedMunicipios: null,
        apiMunicipios: '/api/ubigeos',
        multiple: true,
        placeholder: 'Municipios',
      },
    }),
    mounted() {
      this.$store.dispatch('taxpayer/setTaxpayerRif', { value: null });
      this.$store.dispatch('taxpayer/setTaxpayerId', { value: null });
      this.form.dateStart = moment(this.dateStart).subtract(7, 'days').format('YYYY-MM-DD');
      this.form.decimalPoint = 0.1.toLocaleString().replace(/\d/g, '');
    },
    watch: {
      '$store.state.taxpayer.id': {
        handler() {
          this.form.sucursales = [];
          this.form.series = [];
          this.form.externos = [];
          this.$refs.refExternos.clean();
          this.$refs.refSeries.clean();
          this.$refs.refSucursales.clean();
          this.$refs.refTiposDocumento.clean();
          this.$refs.refMunicipios.clean();
          this.form.municipio = 0;
          this.clearMunicipio();
        },
        deep: true,
      },
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.valid = true;
        }
      },
     /*  getFecha() {
          const fecha = new Date();
          fecha.setDate(fecha.getDate() - 7);
          return fecha.toISOString().split('T')[0];
      }, */
      /* getSalesBook() {
        const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
          if (this.validateContribuyente()) {
            this.validateContribuyente();
            this.downloading = false;
            this.form.busy = false;
        } else if (dateRange > 1) {
            this.$store.dispatch('notifications/show', {
                  message: 'El rango de consulta no debe ser mayor a un mes',
                  type: 'error',
            });
        } else if (this.form.dateEnd < this.form.dateStart) {
            this.$store.dispatch('notifications/show', {
              message: 'La fecha fin no debe ser menor a la fecha inicio',
              type: 'error',
            });
        } else {
          this.form.enterprise_id = this.$store.state.taxpayer.id;
          window.axios
            .get(`api/salebook/getSaleBook/${this.form.enterprise_id}/${this.form.dateStart}/${this.form.dateEnd}`)
              .then((response) => {
              if (response.data.code === 400) {
                this.$store.dispatch('notifications/show', {
                  message: response.data.message,
                  type: response.data.type,
                });
                this.form.busy = false;
                this.downloading = false;
                this.dateCurrent = '';
              } else {
                this.disabled = true;
                window.axios.get(`api/salebook/existSaleBook/${this.form.enterprise_id}/${this.form.dateStart}/${this.form.dateEnd}`)
                  .then((response) => {
                    if (response.data.code === 400) {
                      this.$store.dispatch('notifications/show', {
                        message: response.data.message,
                        type: response.data.type,
                      });
                      this.form.busy = false;
                      this.downloading = false;
                      this.dateCurrent = '';
                    } else if (response.data.code === 0) {
                      const current = moment(response.data.item.created_at, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD');
                      const dateNow = moment().format('YYYY-MM-DD');
                      const days = moment(dateNow).diff(current, 'days', true);

                      if (days < this.daysLimit) {
                        this.dateCurrent = current;
                        this.form.busy = false;
                        this.downloading = false;
                      } else {
                        this.dateCurrent = '';
                        this.disabled = false;
                      }
                    } else {
                      this.disabled = false;
                      this.dateCurrent = '';
                    }
                  });
              }
            });
        }
      }, */
      async getBook() {
        const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
        if (dateRange > 1) {
          this.$store.dispatch('notifications/show', {
                message: 'El rango de consulta no debe ser mayor a un mes',
                type: 'error',
          });
        } else if (this.validateContribuyente()) {
            this.validateContribuyente();
            this.downloading = false;
            this.form.busy = false;
        } else if (this.form.dateEnd < this.form.dateStart) {
            this.$store.dispatch('notifications/show', {
              message: 'La fecha fin no debe ser menor a la fecha inicio',
              type: 'error',
            });
        } else {
          this.validate();
          if (this.$refs.form.validate()) {
            this.downloading = true;
            this.form.enterprise_id = this.$store.state.taxpayer.id;
            this.form.rif = this.$store.state.taxpayer.rif;
            this.form.busy = true;
            this.form.offset = 0;

            const countDocument = await window.axios({
              method: 'post',
              url: '/api/salebook/generatesalesbook/count',
              data: this.form,
            });

            this.totalDocument = countDocument.data.total;
            const laps = this.totalDocument % this.form.limit > 0
                        ? parseInt(this.totalDocument / this.form.limit, 10) + 1
                        : this.totalDocument / this.form.limit;
            for (let i = 0; i < laps; i++) {
              this.laps = laps;
              this.form.end = (this.laps === i + 1);
              // eslint-disable-next-line
              const data = await this.getReport();

              if (data.data.type !== undefined && data.data.type === 'error') {
                this.downloading = false;
                this.form.busy = false;
              } else {
                this.form.offset = (i + 1) * this.form.limit;
                this.downloadFile(data, `Libro de Venta ${i + 1} de ${laps} Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`);
                const value = (this.totalDocument / laps) * (i + 1);
                this.progress = (value / this.totalDocument) * 100;
              }
            }

            setTimeout(() => {
              this.downloading = false;
              this.form.busy = false;
              this.progress = 0;
            }, 1000);
        }
      }
      },
      async getList() {
        const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
        if (dateRange > 1) {
          this.$store.dispatch('notifications/show', {
                message: 'El rango de consulta no debe ser mayor a un mes',
                type: 'error',
          });
        } else if (this.validateContribuyente()) {
            this.validateContribuyente();
            this.downloading = false;
            this.form.busy = false;
        } else if (this.form.dateEnd < this.form.dateStart) {
            this.$store.dispatch('notifications/show', {
              message: 'La fecha fin no debe ser menor a la fecha inicio',
              type: 'error',
            });
        } else {
          this.validate();
          if (this.$refs.form.validate()) {
            this.downloading = true;
            this.form.enterprise_id = this.$store.state.taxpayer.id;
            this.form.rif = this.$store.state.taxpayer.rif;
            this.form.busy = true;
            this.form.offset = 0;

            const countDocument = await window.axios({
              method: 'post',
              url: '/api/salebook/generatesalesbook/count',
              data: this.form,
            });

            this.totalDocument = countDocument.data.total;
            const laps = this.totalDocument % this.form.limit > 0
                        ? parseInt(this.totalDocument / this.form.limit, 10) + 1
                        : this.totalDocument / this.form.limit;
            for (let i = 0; i < laps; i++) {
              this.laps = laps;
              this.form.end = (this.laps === i + 1);
              // eslint-disable-next-line
              const data = await this.getListReport();
              this.form.offset = (i + 1) * this.form.limit;
              this.downloadFileJson(data, `Listado ${i + 1} de ${laps} Fecha ${format(parseISO(new Date().toISOString()), 'dd-MM-yyyy')}`);
              const value = (this.totalDocument / laps) * (i + 1);
              this.progress = (value / this.totalDocument) * 100;
            }

            setTimeout(() => {
              this.downloading = false;
              this.form.busy = false;
              this.progress = 0;
            }, 1000);
          }
        }
      },
      getReport() {
        const url = '/api/salebook/generatesalesbook';
        return window.axios({
          method: 'post',
          url,
          data: this.form,
        }).catch((e) => {
          // eslint-disable-next-line
          console.log(e);
          this.downloading = false;
          this.form.busy = false;
        });
      },
      getListReport() {
        const url = '/api/salebook/generatelist';
        return window.axios({
          method: 'post',
          url,
          data: this.form,
        }).catch((e) => {
          // eslint-disable-next-line
          console.log(e);
          this.downloading = false;
          this.form.busy = false;
        });
      },
      b64DecodeUnicode(str) {
        return decodeURIComponent(atob(str).split('').map((c) => `%${ (`00${ c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
      },
      downloadFile(response, filename) {
        const newBlob = new Blob([this.b64DecodeUnicode(response.data.file)], { type: 'csv' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = (this.form.igtf) ? `${filename} extendido.csv` : `${filename}.csv`;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      downloadFileJson(response, filename) {
        const newBlob = new Blob([this.b64DecodeUnicode(response.data.file)], { type: 'json' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename}.json`;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      validateContribuyente() {
        if (this.$store.state.taxpayer.rif === null) {
            return this.$store.dispatch('notifications/show', {
              message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
              type: 'error',
            });
        }
      },
      changeTipo(value) {
        this.form.externos = [];
        this.externo.selectedExternos = null;
        this.$refs.refExternos.clean();
        if (value === 2) {
          this.showFilters = true;
        } else {
          this.showFilters = false;
        }
      },
      updateSeries(series) {
        this.form.series = [];
        series.forEach((item) => {
          this.form.series.push(item);
        });
      },
      updateExternos(externos) {
        this.form.externos = [];
        externos.forEach((item) => {
          this.form.externos.push(item);
        });
      },
      updateSucursales(sucursales) {
        this.form.sucursales = [];
        sucursales.forEach((item) => {
          this.form.sucursales.push(item);
        });
      },
      updateTiposDocumento(tiposDocumento) {
        this.form.tiposDocumento = [];
        tiposDocumento.forEach((item) => {
          this.form.tiposDocumento.push(item);
        });
      },
      updateMunicipios(municipios) {
        this.form.municipios = [];
        municipios.forEach((item) => {
          this.form.municipios.push(item);
        });
      },
      clearMunicipio() {
        if (this.form.municipio === false) {
          this.$refs.refMunicipios.clean();
          this.form.municipios = [];
        }
      },
      today(menu) {
        if (menu === 'one') {
          this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
          this.form.dateMenu1 = false;
        } else {
          this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
          this.form.dateMenu2 = false;
        }
      },
    },
  };
  </script>
  <style scoped>p
  .flip-card {
    font-size: 2rem !important;
  }
  .flip-clock__slot {
    font-size: 1rem !important;
  }
  .flip-card__top,
  .flip-card__bottom,
  .flip-card__back-bottom,
  .flip-card__back::before,
  .flip-card__back::after {
    color: #ffffff !important;
    background: rgba(35, 127, 233, 0.932) !important;
  }
  </style>
